// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapse-v2{display:grid;grid-template-rows:0fr;transition:grid-template-rows .5s}.collapse-v2.show{grid-template-rows:1fr}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
